import { MenuItem } from '@card-software/library';
import {
  DataMasterAdminGroup,
  DataMasterViewerGroup,
  LapDipRequestRoles,
  LapDipRoles,
  ProductDevelopmentAdminGroup,
  ProductDevelopmentEditorGroup,
  ProductDevelopmentViewerGroup,
  TestLabDipAdminGroup,
} from './models/authorization/enum/user-group.enum';

export const MENU_ITEMS: MenuItem[] = [
  {
    displayName: 'Product Development',
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Yarns',
        routerLink: '/yarns',
        redirect: true,
        roles: [ProductDevelopmentViewerGroup.YarnViewer, ProductDevelopmentAdminGroup.YarnAdmin],
      },
      {
        displayName: 'Greiges',
        routerLink: '/greiges',
        redirect: true,
        roles: [
          ProductDevelopmentViewerGroup.GreigeViewer,
          ProductDevelopmentEditorGroup.GreigeEditor,
          ProductDevelopmentAdminGroup.GreigeAdmin,
        ],
      },
      {
        displayName: 'Fabrics',
        routerLink: '/fabric',
        redirect: true,
        roles: [
          ProductDevelopmentViewerGroup.FabricViewer,
          ProductDevelopmentEditorGroup.FabricEditor,
          ProductDevelopmentAdminGroup.FabricAdmin,
        ],
      },
      {
        displayName: 'Fabric Categories',
        routerLink: '/fabric-categories',
        redirect: true,
        roles: [ProductDevelopmentViewerGroup.FabricCategoriesViewer, ProductDevelopmentAdminGroup.FabricCategoriesAdmin],
      },
      {
        displayName: 'Fiber Categories',
        routerLink: '/fiber-categories',
        redirect: true,
        roles: [ProductDevelopmentViewerGroup.FiberCategoriesViewer, ProductDevelopmentAdminGroup.FiberCategoriesAdmin],
      },
    ],
  },
  {
    displayName: 'Item Master',
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Item Master',
        routerLink: '/item-master',
        redirect: true,
        roles: [DataMasterViewerGroup.ItemMasterViewer, DataMasterAdminGroup.ItemMasterAdmin],
      },
      {
        displayName: 'Item Categories',
        routerLink: '/item-categories',
        redirect: true,
        roles: [DataMasterViewerGroup.ItemCategoriesViewer, DataMasterAdminGroup.ItemCategoriesAdmin],
      },
      {
        displayName: 'Code Creation Requests',
        routerLink: '/code-creation-requests',
        redirect: true,
        roles: [DataMasterViewerGroup.ItemCodeRequestViewer, DataMasterAdminGroup.ItemMasterAdmin],
      },
    ],
  },
  {
    displayName: 'Dyeing',
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Requests',
        routerLink: '/lab-dip-requests',
        redirect: true,
        roles: [LapDipRequestRoles.LabDipRequestViewer, LapDipRequestRoles.LabDipRequestEditor, LapDipRequestRoles.LabDipRequestAdmin],
      },
      {
        displayName: 'Lab Dips',
        routerLink: '/lab-dips',
        redirect: true,
        roles: [LapDipRoles.LabDipViewer, LapDipRoles.LabDipEditor, LapDipRoles.LabDipAdmin],
      },
    ],
  },
  {
    displayName: 'Engineering',
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Processes',
        routerLink: '/processes',
        redirect: true,
        roles: [
          TestLabDipAdminGroup.TestLabDipAdmin,
          ProductDevelopmentAdminGroup.EngineeringAdmin,
          ProductDevelopmentEditorGroup.EngineeringEditor,
          ProductDevelopmentViewerGroup.EngineeringViewer,
        ],
      },
      {
        displayName: 'Steps',
        routerLink: '/steps',
        redirect: true,
        roles: [
          TestLabDipAdminGroup.TestLabDipAdmin,
          ProductDevelopmentAdminGroup.EngineeringAdmin,
          ProductDevelopmentEditorGroup.EngineeringEditor,
          ProductDevelopmentViewerGroup.EngineeringViewer,
        ],
      },
      {
        displayName: 'Parameters',
        routerLink: '/parameters',
        redirect: true,
        roles: [
          TestLabDipAdminGroup.TestLabDipAdmin,
          ProductDevelopmentAdminGroup.EngineeringAdmin,
          ProductDevelopmentEditorGroup.EngineeringEditor,
          ProductDevelopmentViewerGroup.EngineeringViewer,
        ],
      },
    ],
  },
];
